import React from 'react';

import {AnalyticsVisualizationSortDirection as SortDirection} from 'graphql-client/__generated/graphqlGlobalTypes';
import {SORT_DIRECTION_TO_READABLE} from 'insights/analytics-visualizations/AnalyticsVisualizationConstants';
import {StringValueDropdownSelector} from 'insights/analytics-visualizations/configs/form-components/DropdownSelector';
import Tooltip from 'ui-library/bs/Tooltip';
import WarningIcon from 'ui-library/icons/WarningIcon';
import FieldLabel from 'ui-library/inputs/FieldLabel';

export interface SortDirectionConfigEditorProps<
  ChartParameters extends {sortDirection?: SortDirection | null},
> {
  warning?: string | null;
  parameters: ChartParameters;
  onUpdateParameters: (update: Partial<ChartParameters>) => void;
  isDisabled?: boolean;
}

/**
 * Settings to configure sort direction.
 */
export default function SortDirectionConfigEditor<
  ChartParameters extends {sortDirection?: SortDirection | null},
>({
  warning = null,
  parameters,
  onUpdateParameters,
  isDisabled = false,
}: SortDirectionConfigEditorProps<ChartParameters>): JSX.Element {
  return (
    <div>
      <FieldLabel
        label={
          <>
            Sort Direction
            {warning && (
              <Tooltip title={warning}>
                <WarningIcon className="u-tiny-spacing-left" />
              </Tooltip>
            )}
          </>
        }
      />

      <StringValueDropdownSelector
        allowNull={true}
        onChange={(newSortDirection) => {
          onUpdateParameters({...parameters, sortDirection: newSortDirection});
        }}
        searchable={false}
        selectedValue={parameters.sortDirection ?? null}
        values={[SortDirection.ASCENDING, SortDirection.DESCENDING]}
        valueToReadable={(sortDirection) => SORT_DIRECTION_TO_READABLE[sortDirection]}
        isDisabled={isDisabled}
      />
    </div>
  );
}
